import * as React from 'react'
import styled, { css } from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { COMMON, ANIMAL_COLORS, animalColor } from 'global'
import { IHand } from 'models'
import { Flex, IFlexProps, Box } from 'components'

interface IColorPicker extends IFlexProps {
  selectedColor: IHand['color']
  onColorSelect: (color: IHand['color']) => void
}

interface ColorItemProps {
  color: IHand['color']
}

const StyledSlider = styled(Slider)`
  .slick-track {
    display: flex;
    align-items: center;
  }
  .slick-current .coloricon {
    border: 5px solid #fff;
  }
`

const Slide = styled(Box)`
  outline: none;
`

const ColorItem = styled.div<ColorItemProps>`
  ${COMMON}
  ${({ color }) =>
    css`
      margin: auto;
      background-color: ${animalColor(color)};
      height: 35px;
      width: 35px;
      border-radius: 50%;
      border: 5px solid transparent;
      background-clip: padding-box;
    `}
`

export const ColorPicker = ({
  selectedColor,
  onColorSelect,
  ...props
}: IColorPicker) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 250,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: ANIMAL_COLORS.indexOf(selectedColor),
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    swipeToSlide: true,
    focusOnSelect: true,
    afterChange: (i: number) => onColorSelect(ANIMAL_COLORS[i]),
    responsive: [
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    // @ts-ignore styled-system / styled-components clash
    <Flex
      flexDirection='column'
      width='100%'
      /* Fix for Webflow embed */
      overflow='hidden'
      {...props}
    >
      <StyledSlider {...settings}>
        {ANIMAL_COLORS.map(color => (
          <Slide key={color}>
            <ColorItem color={color} className='coloricon' />
          </Slide>
        ))}
      </StyledSlider>
    </Flex>
  )
}
